export class ViewReport {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
        this.modifiedAt = Date.now();
    }
}
ViewReport.$inject = ['init'];
